"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REDUCER_KEY = void 0;
const redux_actions_1 = require("redux-actions");
const immutable_1 = require("immutable");
const core_1 = require("companion-app-components/flux/core");
const core_actions_1 = require("companion-app-components/flux/core-actions");
const actions_1 = require("data/AccountDiscovery/actions");
const actions_2 = require("data/persist/actions");
const actions = __importStar(require("./actions"));
const types_1 = require("./types");
const reducer = (0, redux_actions_1.handleActions)({
    [core_actions_1.coreActions.sanitize]: (state) => state.set('resourcesById', state.resourcesById.map((resource) => resource.merge({
        name: (0, immutable_1.hash)(resource.name).toString(),
    }))),
    [core_actions_1.coreActions.persistDataLoadComplete]: (state) => state.merge({
        isLoading: false,
        isRefreshingAll: false,
        idsRefreshing: (0, immutable_1.Set)(),
        idsRefreshingWithUserActionsPending: (0, immutable_1.Set)(),
        idsRefreshingWithCancelledUserActions: (0, immutable_1.Set)(),
    }),
    [actions.getInstitutionLogins]: (state) => state,
    [actions.getInstitutionLoginsSuccess]: (state, { payload: data }) => core_1.resourceUpserters.upsertResources(state, data),
    // Called when a CRUD operation is successful on transactions. The success
    // action is triggered by the Sagas.
    [(0, redux_actions_1.combineActions)(actions.updateInstitutionLoginSuccess, actions.deleteInstitutionLoginSuccess)]: (state, { payload: institutionLoginToUpsert }) => core_1.resourceUpserters.upsertResource(state, institutionLoginToUpsert),
    [actions.getInstitutionLoginsFailure]: (state, { payload: error }) => core_1.resourceUpserters.completeWithError(state, error),
    [(0, redux_actions_1.combineActions)(actions.updateInstitutionLoginFailure, actions.deleteInstitutionLoginFailure)]: (state, { payload: error, asyncDispatch }) => {
        asyncDispatch(actions.getInstitutionLogins());
        return core_1.resourceUpserters.resetResources(state, error);
    },
    [actions_1.accountDiscoveryCredentialsFormSubmitResponse]: {
        next(state, { payload: { institutionLogin } }) {
            if (!state.resourcesById.get(institutionLogin.id)) {
                // if this was a new institutionLogin (not an update), add to store
                return state.merge({ resourcesById: state.resourcesById.set(institutionLogin.id, institutionLogin) });
            }
            return state;
        },
    },
    [actions.refreshAccounts]: (state, { payload: data }) => {
        if (data && data.institutionLoginId) {
            return state.set('idsRefreshing', state.idsRefreshing.add(data.institutionLoginId));
        }
        return state.set('isRefreshingAll', true);
    },
    [actions.refreshAccountsStatuses]: (state, { payload: refreshStatuses, asyncDispatch }) => {
        let { credentialBlobsForRefreshingLogins, credentialsForRefreshingLogins } = state;
        refreshStatuses.institutionLogins.forEach((login) => {
            if (login.credentialsBlob) {
                credentialBlobsForRefreshingLogins = credentialBlobsForRefreshingLogins.set(login.id, login.credentialsBlob);
                credentialsForRefreshingLogins = credentialsForRefreshingLogins.delete(login.id);
            }
        });
        if (credentialBlobsForRefreshingLogins !== state.credentialBlobsForRefreshingLogins) {
            // action to persist the credentials blobs to persistent storage
            asyncDispatch((0, actions_2.saveInstitutionLoginsCredentialBlobs)(credentialBlobsForRefreshingLogins));
        }
        return state.merge({ credentialBlobsForRefreshingLogins, credentialsForRefreshingLogins });
    },
    [actions.refreshAccountsTriggeredMfa]: (state, { payload: id }) => state.set('idsRefreshingWithUserActionsPending', state.idsRefreshingWithUserActionsPending.add(id)),
    [actions.refreshAccountsCredentialsProvided]: (state, { payload: { institutionLogin } }) => {
        let { credentialsForRefreshingLogins } = state;
        if (institutionLogin.credentials != null) {
            credentialsForRefreshingLogins =
                credentialsForRefreshingLogins.set(institutionLogin.id, institutionLogin.credentials);
        }
        return state.merge({
            idsRefreshingWithUserActionsPending: state.idsRefreshingWithUserActionsPending.delete(institutionLogin.id),
            credentialsForRefreshingLogins,
        });
    },
    [(0, redux_actions_1.combineActions)(actions.refreshAccountsCredentialsNotProvided, actions.refreshAccountsMfaNotProvided)]: (state, { payload: id }) => (state.merge({
        idsRefreshingWithCancelledUserActions: state.idsRefreshingWithCancelledUserActions.add(id),
        idsRefreshingWithUserActionsPending: state.idsRefreshingWithUserActionsPending.delete(id),
    })),
    [actions.refreshAccountsMfaFormSubmitResponse]: {
        next(state, { payload: { institutionLoginId } }) {
            return state.set('idsRefreshingWithUserActionsPending', state.idsRefreshingWithUserActionsPending.delete(institutionLoginId));
        },
        throw(state, { payload: error }) {
            const { institutionLoginId } = error;
            return state.merge({
                idsRefreshingWithCancelledUserActions: state.idsRefreshingWithCancelledUserActions.add(institutionLoginId),
                idsRefreshingWithUserActionsPending: state.idsRefreshingWithUserActionsPending.delete(institutionLoginId),
            });
        },
    },
    [actions.refreshAccountsCompleted]: (state, { payload }) => {
        const { institutionLoginId } = payload;
        if (institutionLoginId) {
            return state.merge({
                idsRefreshing: state.idsRefreshing.remove(institutionLoginId),
                idsRefreshingWithUserActionsPending: state.idsRefreshingWithUserActionsPending.remove(institutionLoginId),
                idsRefreshingWithCancelledUserActions: state.idsRefreshingWithCancelledUserActions.remove(institutionLoginId),
                credentialsForRefreshingLogins: state.credentialsForRefreshingLogins.remove(institutionLoginId),
            });
        }
        return state.merge({
            isRefreshingAll: false,
            idsRefreshing: state.idsRefreshing.clear(),
            idsRefreshingWithUserActionsPending: state.idsRefreshingWithUserActionsPending.clear(),
            idsRefreshingWithCancelledUserActions: state.idsRefreshingWithCancelledUserActions.clear(),
            credentialsForRefreshingLogins: state.credentialsForRefreshingLogins.clear(),
        });
    },
    [actions.addInstitutionLoginAndAccountsResponse]: {
        next: (state, { payload: { institutionLogin } }) => {
            let newState = core_1.resourceUpserters.upsertResource(state, institutionLogin);
            newState = newState.set('idsRefreshing', state.idsRefreshing.add(institutionLogin.id));
            return newState;
        },
    },
    [actions.institutionLoginSetCredentialsBlob]: (state, { payload, asyncDispatch }) => {
        const { institutionLoginId, credentialsBlob } = payload;
        let { credentialBlobsForRefreshingLogins, credentialsForRefreshingLogins } = state;
        credentialBlobsForRefreshingLogins = credentialBlobsForRefreshingLogins.set(institutionLoginId, credentialsBlob);
        credentialsForRefreshingLogins = credentialsForRefreshingLogins.delete(institutionLoginId);
        // action to persist the credentials blobs to persistent storage
        asyncDispatch((0, actions_2.saveInstitutionLoginsCredentialBlobs)(credentialBlobsForRefreshingLogins));
        return state.merge({ credentialBlobsForRefreshingLogins, credentialsForRefreshingLogins });
    },
    // action to load data into redux from persistent storage
    [actions_2.loadedInstitutionLoginsCredentialBlobs]: (state, { payload: credentialsBlobs }) => {
        let { credentialBlobsForRefreshingLogins, credentialsForRefreshingLogins } = state;
        credentialBlobsForRefreshingLogins = credentialsBlobs;
        credentialsForRefreshingLogins = credentialsForRefreshingLogins.clear();
        return state.merge({ credentialBlobsForRefreshingLogins, credentialsForRefreshingLogins });
    },
    [actions.qcsInstitutionLoginActionResponse]: {
        next(state, { payload: institutionLogin }) {
            return core_1.resourceUpserters.upsertResource(state, institutionLogin, false);
        },
        throw(state, _error) {
            return state;
        },
    },
    [actions.updateChangedInstitutionLogins]: (state, { payload: institutionLogins }) => core_1.resourceUpserters.upsertResources(state, core_1.resourceStoreTypes.mkQcsSyncResourcesPayload({ resources: institutionLogins })),
}, (0, types_1.mkInstitutionLoginsStore)());
exports.REDUCER_KEY = 'institutionLoginsStore';
exports.default = reducer;
